export default class ZipInToastMessage {
    static getZipCodeToastLabel(localizedInformationOrTranslations, zipCode) {
        const zipCodeLabel = 'translations' in localizedInformationOrTranslations
            ? localizedInformationOrTranslations.translations.zipCodeSelectedMessage
            : localizedInformationOrTranslations.zipCodeSelectedMessage;
        const stringToReplace = 'zip_code';
        const zipCodeToUpperCase = zipCode.toUpperCase();
        const label = zipCodeLabel
            .replace(`[[${stringToReplace}]]`, zipCodeToUpperCase)
            .replace(`{{${stringToReplace}}}`, zipCodeToUpperCase);
        return {
            label
        };
    }
}
//# sourceMappingURL=ZipInToastMessage.js.map